import {
  AnalyticsControllerService,
  type EventTypeCountStats,
} from '../services/widget-analytics';
import type { CountryFilterMode } from '../components/CountryFilterDropdown';

export type AnalyticsResponse = EventTypeCountStats;
export type AnalyticsPayload = {
  agentId: string;
  start: string;
  end: string;
  distinct?: boolean;
  mode?: CountryFilterMode;
  countries?: Array<string>;
};

export const getWidgetAnalytics = (payload: AnalyticsPayload) => {
  return AnalyticsControllerService.getEventTypeStats(
    payload.agentId,
    payload.start,
    payload.end,
    payload.distinct,
    payload.mode,
    payload.countries
  );
};
export const getWidgetAnalyticsCountries = (
  agentId?: string,
  start?: string,
  end?: string
) => {
  return AnalyticsControllerService.getCountries(agentId, start, end);
};
